var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from 'react';
import styled from 'styled-components';
import { colors } from '../../../defaultTheme';
import { getPrimaryStyles, getSecondaryAndGhostStyles, getTextStyles } from './helpers';
const StyledButton = styled.button `
  position: relative;
  font-family: Open Sans;
  font-size: 14px;
  min-width: 120px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  color: ${({ disabled, theme }) => disabled ? colors.mediumGrey : theme.button.background};
  overflow: hidden;
  font-weight: 700;
  margin: 8px;

  ${(props) => {
    const { buttonType, theme, disabled } = props;
    if (buttonType === 'primary' || buttonType === 'primary-destroy') {
        return getPrimaryStyles(buttonType, theme, disabled, props);
    }
    if (buttonType === 'secondary' || buttonType === 'ghost') {
        return getSecondaryAndGhostStyles(buttonType, theme, disabled, props);
    }
    if (buttonType === 'text' || buttonType === 'text-destroy') {
        return getTextStyles(buttonType, theme);
    }
    return '';
}}
`;
const Button = forwardRef((_a, ref) => {
    var { buttonType, dataCy, disabled = false, alt, type = 'button', children, onClick, className, ariaLabel, title } = _a, props = __rest(_a, ["buttonType", "dataCy", "disabled", "alt", "type", "children", "onClick", "className", "ariaLabel", "title"]);
    return (React.createElement(StyledButton, Object.assign({ className: className, buttonType: buttonType, disabled: disabled, alt: alt, "aria-label": ariaLabel, onClick: onClick, type: type, "data-object": "button", ref: ref, title: title, "data-cy": dataCy }, props), children));
});
export default Button;
